import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_2 = { class: "p-recommend-form__list-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__heading-1" }, "資格", -1)
const _hoisted_4 = { class: "p-recommend-form__error-wrap" }
const _hoisted_5 = { class: "p-recommend-form__group-1" }
const _hoisted_6 = { class: "p-recommend-form__group-1-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 資格名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "resume-icon-wrapper --auto-right1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "履"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "職")
  ])
], -1)
const _hoisted_8 = { class: "p-recommend-form__group-1-block-1" }
const _hoisted_9 = { class: "p-recommend-form__group-1-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 資格取得年月 "),
  /*#__PURE__*/_createElementVNode("span", { class: "resume-icon-wrapper --auto-right1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "履"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "職")
  ])
], -1)
const _hoisted_11 = { class: "p-recommend-form__group-1-block-1" }
const _hoisted_12 = { class: "--wrap-1" }
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "資格", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "を削除する", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "資格を追加する", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "p-recommend-form__field" }
const _hoisted_21 = { class: "p-recommend-form__group-1-field" }
const _hoisted_22 = { class: "p-recommend-form__error-wrap" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" その他特記すべき事項 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)

import InvalidMessage from '@/components/InvalidMessage.vue';
import YearMonthSelect from '../../components/YearMonthSelect.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSearch from '../../components/ResumeSearch.vue';
import { TrnCareerResumeUpdateForm } from '@/types';
import { ref, watch } from 'vue';
import { useFieldValue, useFormValues, ValidationResult } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'QualLicense',
  props: {
    qualDetailCount: null,
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
  qualDetailCount: number;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
}

const MAX_LICENSES = 20;
const licenseItems = ref([0]); // Initialize with one item
const formValues = useFormValues<TrnCareerResumeUpdateForm>();



const toEmpty = (v: any) => v ? v : '';

const minYearSelect = ref<number>(0);
const maxYearSelect = ref<number>(0);
const birthDateYValue = useFieldValue('birthDateY');
watch(birthDateYValue, (newVal: any) => {
  if (newVal) {
    minYearSelect.value = newVal + 13;
    maxYearSelect.value = newVal + 100;
  }
});

function addLicense() {
  if (licenseItems.value.length >= MAX_LICENSES) return;
  licenseItems.value.push(Math.random());

  const len = licenseItems.value.length - 1;
  props.setFieldValue(`qualDetails[${len}].licenseId`, '');
  props.setFieldValue(`qualDetails[${len}].qualYr`, '');
  props.setFieldValue(`qualDetails[${len}].qualMon`, '');
}
async function removeLicense(idx: number) {
  if (licenseItems.value.length > 1) {
    const len = licenseItems.value.length;
    for (let i = idx; i < len - 1; i++) {
      if (formValues.value.qualDetails) {
        const qual = formValues.value.qualDetails[i + 1] ?? {};
        props.setFieldValue(`qualDetails[${i}].licenseId`, toEmpty(qual.licenseId));
        props.setFieldValue(`qualDetails[${i}].qualYr`, toEmpty(qual.qualYr));
        props.setFieldValue(`qualDetails[${i}].qualMon`, toEmpty(qual.qualMon));

        const serchText = document.querySelector(`[name="qualDetails[${i}].licenseId_text$"]`) as HTMLInputElement;
        const serchTextNext = document.querySelector(`[name="qualDetails[${i + 1}].licenseId_text$"]`) as HTMLInputElement;
        if (serchText && serchTextNext) {
          serchText.value = serchTextNext.value;
        }
        if ((qual.qualYr && !qual.qualMon) || (!qual.qualYr && qual.qualMon)) {
          await props.validateField(`qualDetails[${i}].qualYr`);
          await props.validateField(`qualDetails[${i}].qualMon`);
        }
      }
    }
    licenseItems.value.pop();
  }
}

watch(() => props.qualDetailCount, (newVal) => {
  if (newVal > 0) {
    licenseItems.value = Array.from({length: newVal}, () => Math.random());
  } else {
    // If no valid entries, keep at least one item
    licenseItems.value = [Math.random()];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(licenseItems.value, (license, i) => {
          return (_openBlock(), _createElementBlock("li", { key: license }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(InvalidMessage, {
                name: `qualDetails[${i}].qualYr`
              }, null, 8, ["name"]),
              _createVNode(InvalidMessage, {
                name: `qualDetails[${i}].qualMon`
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(ValidatableField, {
                    type: "hidden",
                    name: `qualDetails[${i}].qlId`
                  }, null, 8, ["name"]),
                  _createVNode(ResumeSearch, {
                    name: `qualDetails[${i}].licenseId`,
                    label: "資格名",
                    id: "licenses"
                  }, null, 8, ["name"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(YearMonthSelect, {
                      name: {year: `qualDetails[${i}].qualYr`, month: `qualDetails[${i}].qualMon`},
                      label: "資格取得",
                      "max-year": maxYearSelect.value,
                      "min-year": minYearSelect.value
                    }, null, 8, ["name", "max-year", "min-year"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "p-recommend-form__delete-2",
              type: "button",
              onClick: ($event: any) => (removeLicense(i)),
              disabled: licenseItems.value.length <= 1
            }, _hoisted_16, 8, _hoisted_13)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        class: "p-recommend-form__add --mt-3",
        type: "button",
        onClick: addLicense,
        disabled: licenseItems.value.length >= MAX_LICENSES
      }, _hoisted_19, 8, _hoisted_17)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(InvalidMessage, { name: "qualOther" })
        ]),
        _hoisted_23,
        _createVNode(ValidatableField, {
          as: "textarea",
          rules: "max:30000",
          maxlength: "30000",
          name: "qualOther",
          label: "その他特記すべき事項",
          class: "p-recommend-form__textarea",
          id: "form-qualification-message-1",
          placeholder: "入力してください"
        })
      ])
    ])
  ], 64))
}
}

})